import { Grid, Paper, Typography } from '@mui/material';
import type { BillingCycleInvoiceType } from '@weft/api-definition';
import { BILLING_CYCLE_INVOICE_TYPES } from '@weft/api-definition';
import React from 'react';
import { InvoicePreview } from './InvoicePreview';

type BillingCycleSidebarProps = {
  selectedInvoiceType: BillingCycleInvoiceType;
  onInvoicePreviewClick: (selected: BillingCycleInvoiceType) => void;
  regularBillingCycleInvoicesCount: number;
  inspectionBillingCycleInvoicesCount: number;
  oldBillingCycleInvoicesCount: number;
  overcharges: number;
  loading?: boolean;
};

export const BillingCycleSidebar:React.FC<BillingCycleSidebarProps> = ({
  selectedInvoiceType,
  onInvoicePreviewClick,
  regularBillingCycleInvoicesCount,
  inspectionBillingCycleInvoicesCount,
  oldBillingCycleInvoicesCount,
  overcharges,
  loading = false,
}) => {
  const totalInvoicesInBillingCycle = regularBillingCycleInvoicesCount + inspectionBillingCycleInvoicesCount + oldBillingCycleInvoicesCount;

  return (
    <Paper sx={theme => ({
      borderRadius: '8px',
      border: '1px solid',
      borderColor: theme.palette.divider,
      padding: '24px',
    })}
    >
      <Typography
        display="flex"
        columnGap="8px"
        alignItems="baseline"
        marginBottom={2}
      >
        <Typography
          variant="h5"
          fontWeight={600}
        >
          {totalInvoicesInBillingCycle}
        </Typography>
        <Typography variant="h6">Total Invoices</Typography>
      </Typography>
      <Grid
        container
        spacing={1}
      >
        <Grid
          item
          xs={12}
          md={4}
          lg={12}
        >
          <InvoicePreview
            title="Invoices"
            value={regularBillingCycleInvoicesCount}
            onClick={() => onInvoicePreviewClick(BILLING_CYCLE_INVOICE_TYPES.REGULAR)}
            selected={selectedInvoiceType === BILLING_CYCLE_INVOICE_TYPES.REGULAR}
            loading={loading}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          lg={12}
        >
          <InvoicePreview
            title="Invoices for review"
            value={inspectionBillingCycleInvoicesCount}
            selected={selectedInvoiceType === BILLING_CYCLE_INVOICE_TYPES.INSPECTION}
            onClick={() => onInvoicePreviewClick(BILLING_CYCLE_INVOICE_TYPES.INSPECTION)}
            overcharges={overcharges}
            loading={loading}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          lg={12}
        >
          <InvoicePreview
            title="Older invoices"
            value={oldBillingCycleInvoicesCount}
            selected={selectedInvoiceType === BILLING_CYCLE_INVOICE_TYPES.OLD}
            onClick={() => onInvoicePreviewClick(BILLING_CYCLE_INVOICE_TYPES.OLD)}
            loading={loading}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};